exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".View {\n  max-width: 1080px;\n  margin-left: auto;\n  margin-right: auto; }\n  .View:after {\n    content: \" \";\n    display: block;\n    clear: both; }\n  .View-content {\n    width: 95.83333%;\n    float: left;\n    margin-left: 2.08333%;\n    margin-right: 2.08333%; }\n", ""]);

// exports
